import axios from 'axios'
import settings from 'settings'
import selectors from './selectors'

const url = (path) => [settings.api, path].join('/').replace(/\/+/g, '/')
const projectUrl = (state, path) => {
  const activeProjectId = selectors.user.activeProjectId(state)
  if(!activeProjectId) throw new Error(`no activeProjectId found`)
  return url(`/projects/${activeProjectId}${path}`)
}

// catch bad status codes and run an error handler
// otherwise return the data property of the response
const process = res => {
  if(res.status >= 400) return Promise.reject(`status: ${res.status}`)
  return res.data
}

const setToken = token => {
  axios.defaults.headers.common = {
    Authorization: `Bearer ${token}`
  }
}

const api = {
  url,
  projectUrl,
  process,
  setToken,
}

export default api